import { render } from "./StatViewManagerData.vue?vue&type=template&id=b0e759f6"
import script from "./StatViewManagerData.vue?vue&type=script&lang=js"
export * from "./StatViewManagerData.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__